<template>
  <div class="award">
    <!-- <div class="award-info-title" style="text-align: center; padding-bottom: 20px; font-size: 20px; color: #fff">电子证书查询</div> -->
    <div class="award-contanier">
      <!-- <el-steps :active="active" align-center>
        <el-step title="电子证书查询"></el-step>
        <el-step title="证书查询结果"></el-step>
        <el-step title="证书下载"></el-step>
      </el-steps> -->
      <div class="step">
        <div class="step-item" @click="handleStep(item.num)" :class="active == item.num ? 'active' : ''" v-for="(item, index) in navList" :key="index">
          <div class="step-item-num">{{ item.num }}</div>
          <div class="step-item-title">{{ item.title }}</div>
        </div>
      </div>
      <!-- 0 -->
      <div v-if="active == 1" style="margin-top: 20px;">
        <el-form :model="awardInfo" label-width="90px" label-position="left" class="award-form">
          <el-form-item label="奖项类别" required>
            <el-select size="small" v-model="awardInfo.type" placeholder="请选择" style="width: 100%;" clearable>
              <el-option label="项目奖" :value="2"></el-option>
              <el-option label="个人奖" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申报年份" required>
            <el-select size="small" v-model="awardInfo.year" placeholder="请选择" style="width: 100%;" clearable>
              <el-option :label="item.particularYear" :value="item.id" v-for="(item, index) in yearList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" required>
            <el-input size="small" v-model.trim="awardInfo.name" placeholder="请输入姓名" ></el-input>
          </el-form-item>
          <el-form-item label="身份证号" required>
            <el-input size="small" v-model.trim="awardInfo.identity" placeholder="请输入身份证号" ></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input size="small" v-model.trim="awardInfo.phone" placeholder="请输入手机号" ></el-input>
          </el-form-item>
          <div style="margin: 30px 0 10px; text-align: center;">
            <el-button size="small" style="width: 100%; " type="primary" :loading="awardInfo.loading" @click="handleSearch">查询</el-button>
          </div>
        </el-form>
      </div>
      <!-- 1 -->
      <div v-if="active == 2" style="padding: 10px 0;">
        <div style="font-size: 16px; margin-bottom: 20px">
          <span v-if="awardInfo.type == 2">项目奖查询结果</span>
          <span v-if="awardInfo.type == 1">个人奖查询结果</span>
        </div>
        <el-table :data="tableData" max-height="400" stripe border highlight-current-row :header-cell-style="{ color: '#333'}" style="width: 100%; margin-top: 10px;">
          <el-table-column label="序号" type="index" width="55"></el-table-column>
          <el-table-column label="申报单号" prop="projectCode" width="120" align="center"></el-table-column>
          <el-table-column :label="awardInfo.type == 2 ? '项目名称': '姓名'" prop="projectName" align="center"></el-table-column>
          <el-table-column label="奖项" prop="submitTime" width="95" align="center">
            <template slot-scope="scope">
              <!-- 项目奖 -->
              <span v-if="awardInfo.type == 2">
                <span v-if="scope.row.awardsLv === 0">特等奖</span>
                <span v-if="scope.row.awardsLv === 1">一等奖</span>
                <span v-if="scope.row.awardsLv === 2">二等奖</span>
                <span v-if="scope.row.awardsLv === 3">三等奖</span>
              </span>
              <!-- 个人奖 -->
              <span v-if="awardInfo.type == 1">
                <span>{{ scope.row.categoryName }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="city" width="80" align="center">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="dtl(scope.row, scope.$index)" >查看</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { increasedPersonalGetBatchYears, increasedGetAllDetail } from '@/api/increased'
export default {
  data() {
    return {
      awardInfo: {
        loading: false,
        type: '',
        year: '',
        name: '',
        identity: '',
        phone: ''
      },
      navList: [
        { num: 1, title: '电子证书查询' },
        { num: 2, title: '证书查询结果' },
        { num: 3, title: '证书下载' }
      ],
      active: 1,
      tableData: [],
      yearList: []
    }
  },
  created() {
    increasedPersonalGetBatchYears({}).then(res => {
      if (res.code == '000') {
        this.yearList = res.result
      }
    })
  },
  methods: {
    dtl(row, index) {
      const url = '/api/system/static/' + row.path
      window.open(url, '_blank')
    },
    handleSearch() {
      if (this.awardInfo.type == '' && this.awardInfo.year == '' && this.awardInfo.name == '' && this.awardInfo.identity == '' && this.awardInfo.phone == '') {
        this.$message.warning('请输入查询信息')
        return false
      }
      if (this.awardInfo.type == '') {
        this.$message.warning('请选择奖项类别')
        return false
      }
      if (this.awardInfo.year == '') {
        this.$message.warning('请选择申报年份')
        return false
      }
      if (this.awardInfo.name == '') {
        this.$message.warning('请输入姓名')
        return false
      }
      if (this.awardInfo.identity == '') {
        this.$message.warning('请输入身份证号')
        return false
      }
      if (this.awardInfo.phone == '') {
        this.$message.warning('请输入手机号')
        return false
      }
      // this.active = 2
      const params = {
        type: this.awardInfo.type,
        batchId: this.awardInfo.year,
        name: this.awardInfo.name,
        idenId: this.awardInfo.identity,
        phone: this.awardInfo.phone
      }
      this.awardInfo.loading = true
      increasedGetAllDetail(params).then(res => {
        this.awardInfo.loading = false
        if (res.code == '000') {
          this.tableData = res.result
          if (res.result.length > 0) {
            this.active = 2
          } else {
            this.$message.error('您输入信息有误，请重新输入')
          }
        }
      })
    },
    handleStep(num) {
      if (num == this.active || num == 3 || num == 2) return false
      this.active = num
    },
    g() {
      increasedGetAllDetail()
    }
  }
}
</script>
<style lang="less" scoped>
.step {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  .step-item.active {
    color: #409EFF;
    .step-item-num {
      background-color: #409EFF;
    }
    .step-item-num::before,.step-item-num::after {
      background-color: #409EFF;
    }
  }
  .step-item {
    width: 146px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    color: #AEAEAE;
    position: relative;
    cursor: pointer;
    .step-item-num {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: #C0C4CC;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;
      position: relative;
    }
    .step-item-num::before {
      position: absolute;
      content: "";
      width: 60px;
      height: 4px;
      top: 11px;
      left: -60px;
      background-color: #C0C4CC;
    }
    .step-item-num::after {
      position: absolute;
      content: "";
      width: 60px;
      height: 4px;
      top: 11px;
      right: -60px;
      background-color: #C0C4CC;
    }
  }
}
.award {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  overflow: hidden;
  background: url(../assets/images/login.jpg) no-repeat;
  background-size: cover;
  .award-contanier {
    width: 500px;
    padding: 10px 50px 20px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 6px;
    .tab {
      width: 100%;
      display: flex;
      div {
        flex: 1;
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 4px solid rgb(233 233 233);
        box-sizing: border-box;
        cursor: pointer;
        font-size: 18px;
      }
      div.active {
        border-bottom: 4px solid rgb(64 158 255);
      }
    }
  }
  .award-info-contanier {
    width: 600px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 6px;
    .award-info-title {
      padding: 20px 0;
      font-size: 18px;
      text-align: center;
      position: relative;
    }
    .award-info-title::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 10em;
      height: 2px;
      background-color: rgb(64 158 255);
      border-radius: 2px;
    }
  }
  .award-info {
    max-height: 68vh;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;
    .award-info-item {
      margin-bottom: 10px;
      padding: 10px 40px;
    }
    .award-info-item + .award-info-item {
      border-top: 1px dashed #ddd;
      // border-top: 1px dashed red;
    }
  }

  .award-info::-webkit-scrollbar {
    width: 12px;
    height: 4px;
  }
  .award-info::-webkit-scrollbar-thumb {
    border: 4px solid transparent;
    background-clip: padding-box;
    border-radius: 7px;
    background-color: rgb(201,205,212);
  }
}

</style>

<style lang="less">
.award-form {
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-form-item__label,.el-form-item__content {
    line-height: 32px;
  }
}
.el-table__body-wrapper::-webkit-scrollbar {
  // width: 10px; /* for Chrome, Safari, and Opera */
  width: 12px;
    height: 4px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  // background-color: darkgrey;
  // border-radius: 10px;
  border: 4px solid transparent;
    background-clip: padding-box;
    border-radius: 7px;
    background-color: rgb(201,205,212);
}
// .el-table__body-wrapper::-webkit-scrollbar-track {
//   background-color: lightgrey;
// }
// .el-table__body-wrapper {
//   -ms-overflow-style: scrollbar;  /* for Internet Explorer, Edge */
// }

</style>
